// @ts-nocheck
import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Download, Sparkles, Loader2 } from 'lucide-react';
import jsPDF from 'jspdf';

export const PreAuditPDFLePresident: React.FC = () => {
  const [isGenerating, setIsGenerating] = useState(false);

  const generatePDF = async () => {
    setIsGenerating(true);
    
    try {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pw = pdf.internal.pageSize.getWidth();
      const ph = pdf.internal.pageSize.getHeight();
      const m = 18;
      const cw = pw - 2 * m;
      let y = m;
      let pageNum = 1;

      // Couleurs
      const gold = [218, 165, 32];
      const darkGold = [180, 130, 20];
      const black = [31, 41, 55];
      const gray = [107, 114, 128];
      const lightGray = [245, 245, 245];
      const white = [255, 255, 255];
      const red = [220, 38, 38];
      const green = [34, 197, 94];
      const orange = [251, 146, 60];
      const blue = [59, 130, 246];
      const purple = [168, 85, 247];

      const addPage = () => {
        pdf.addPage();
        y = m;
        pageNum++;
      };

      const checkSpace = (needed: number) => {
        if (y + needed > ph - m - 20) {
          addPage();
          return true;
        }
        return false;
      };

      const addFooter = (summary?: string) => {
        if (summary) {
          pdf.setFontSize(8);
          pdf.setTextColor(...gray);
          pdf.setFont('helvetica', 'italic');
          const lines = pdf.splitTextToSize(summary, cw);
          pdf.text(lines, pw / 2, ph - 22, { align: 'center' });
        }
        
        pdf.setDrawColor(...gold);
        pdf.setLineWidth(0.5);
        pdf.line(m, ph - 15, pw - m, ph - 15);
        pdf.setFontSize(8);
        pdf.setTextColor(...gray);
        pdf.setFont('helvetica', 'normal');
        pdf.text('CONFIDENTIEL - STRATOS', m, ph - 8);
        pdf.text(`Page ${pageNum}/12`, pw - m, ph - 8, { align: 'right' });
      };

      const addSection = (title: string, subtitle?: string) => {
        checkSpace(18);
        pdf.setFillColor(...gold);
        pdf.rect(m, y, cw, 12, 'F');
        pdf.setTextColor(...white);
        pdf.setFontSize(14);
        pdf.setFont('helvetica', 'bold');
        pdf.text(title, m + 4, y + 8);
        y += 14;
        
        if (subtitle) {
          pdf.setFontSize(9);
          pdf.setTextColor(...gray);
          pdf.setFont('helvetica', 'italic');
          pdf.text(subtitle, m, y);
          y += 7;
        }
      };

      // PAGE 1: COUVERTURE
      pdf.setFillColor(...lightGray);
      pdf.rect(0, 0, pw, ph, 'F');
      pdf.setFillColor(...gold);
      pdf.rect(0, 0, pw, 60, 'F');
      pdf.setFillColor(...darkGold);
      pdf.rect(0, 60, pw, 3, 'F');
      
      pdf.setTextColor(...white);
      pdf.setFontSize(48);
      pdf.setFont('helvetica', 'bold');
      pdf.text('STRATOS', pw / 2, 32, { align: 'center' });
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Digital Strategy for Restaurants', pw / 2, 48, { align: 'center' });

      y = 85;
      pdf.setFillColor(...red);
      pdf.roundedRect(pw / 2 - 40, y, 80, 9, 2, 2, 'F');
      pdf.setTextColor(...white);
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'bold');
      pdf.text('CONFIDENTIEL', pw / 2, y + 6, { align: 'center' });

      y = 115;
      pdf.setTextColor(...black);
      pdf.setFontSize(40);
      pdf.text('Pre-Audit Digital', pw / 2, y, { align: 'center' });
      y += 18;
      pdf.setTextColor(...gold);
      pdf.setFontSize(32);
      pdf.text('Le President', pw / 2, y, { align: 'center' });

      y += 22;
      pdf.setTextColor(...gray);
      pdf.setFontSize(12);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Lyon 6eme - Chef Christophe Marguin', pw / 2, y, { align: 'center' });

      y += 28;
      pdf.setFillColor(...white);
      pdf.roundedRect(pw / 2 - 70, y, 140, 50, 3, 3, 'F');
      pdf.setDrawColor(...gold);
      pdf.setLineWidth(1.5);
      pdf.roundedRect(pw / 2 - 70, y, 140, 50, 3, 3, 'S');

      y += 11;
      pdf.setTextColor(...gray);
      pdf.setFontSize(10);
      pdf.text('Score WooRank', pw / 2, y, { align: 'center' });
      y += 16;
      pdf.setTextColor(...orange);
      pdf.setFontSize(48);
      pdf.setFont('helvetica', 'bold');
      pdf.text('59', pw / 2 - 16, y, { align: 'center' });
      pdf.setFontSize(26);
      pdf.setTextColor(...gray);
      pdf.text('/100', pw / 2 + 14, y, { align: 'left' });
      y += 12;
      pdf.setFontSize(10);
      pdf.setTextColor(...green);
      pdf.text('Potentiel: 85/100', pw / 2, y, { align: 'center' });

      addFooter();

      // PAGE 2: SYNTHESE
      addPage();
      addSection('Synthese Executive');
      
      const kpiW = (cw - 10) / 3;
      let kx = m;
      [[orange, 'Trafic', '3,150', 'visites/mois'],
       [[234, 179, 8], 'Position', '24.5', 'Page 3'],
       [red, 'Top 10', '0', 'sur 87 KW']
      ].forEach(([col, lab, val, unit]) => {
        pdf.setFillColor(254, 254, 254);
        pdf.roundedRect(kx, y, kpiW, 30, 2, 2, 'F');
        pdf.setDrawColor(...(col as number[]));
        pdf.setLineWidth(1);
        pdf.roundedRect(kx, y, kpiW, 30, 2, 2, 'S');
        pdf.setFontSize(9);
        pdf.setTextColor(...gray);
        pdf.setFont('helvetica', 'normal');
        pdf.text(lab as string, kx + kpiW / 2, y + 7, { align: 'center' });
        pdf.setFontSize(22);
        pdf.setTextColor(...black);
        pdf.setFont('helvetica', 'bold');
        pdf.text(val as string, kx + kpiW / 2, y + 18, { align: 'center' });
        pdf.setFontSize(8);
        pdf.setTextColor(...gray);
        pdf.setFont('helvetica', 'normal');
        pdf.text(unit as string, kx + kpiW / 2, y + 25, { align: 'center' });
        kx += kpiW + 5;
      });

      y += 36;
      pdf.setFillColor(...black);
      pdf.roundedRect(m, y, cw, 36, 3, 3, 'F');
      y += 9;
      pdf.setTextColor(...gold);
      pdf.setFontSize(15);
      pdf.setFont('helvetica', 'bold');
      pdf.text('OPPORTUNITE', m + 5, y);
      y += 8;
      pdf.setTextColor(200, 200, 200);
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Manque a gagner: 300-500k EUR/an', m + 5, y);
      y += 6;
      pdf.text('Potentiel An 1: 120-300k EUR', m + 5, y);
      y += 6;
      pdf.text('ROI: 300-450%', m + 5, y);

      y += 18;
      addFooter('Situation actuelle sous-optimale - Fort potentiel de croissance identifie');

      // PAGE 3: MOTS-CLES
      addPage();
      addSection('Mots-cles Strategiques');

      pdf.setFillColor(...black);
      pdf.rect(m, y, cw, 10, 'F');
      pdf.setFontSize(9);
      pdf.setTextColor(...white);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Mot-cle', m + 4, y + 7);
      pdf.text('Vol.', m + 95, y + 7, { align: 'right' });
      pdf.text('Pos.', m + 125, y + 7, { align: 'right' });
      pdf.text('Statut', pw - m - 4, y + 7, { align: 'right' });
      y += 10;

      [
        ['le president lyon', 680, 2, 'OK', green],
        ['restaurant le president', 320, 3, 'OK', green],
        ['president lyon 6', 240, 5, 'Moyen', orange],
        ['restaurant lyon 6', 3800, 32, 'Critique', red],
        ['restaurant gastronomique lyon', 2400, 35, 'Critique', red],
        ['restaurant traditionnel lyon', 920, 40, 'Critique', red],
        ['restaurant groupe lyon 6', 380, 45, 'Critique', red],
        ['restaurant romantique lyon', 1200, 38, 'Critique', red]
      ].forEach(([kw, vol, pos, stat, col], i) => {
        if (i % 2 === 0) {
          pdf.setFillColor(252, 252, 252);
          pdf.rect(m, y - 3, cw, 6.5, 'F');
        }
        pdf.setFontSize(9);
        pdf.setTextColor(...black);
        pdf.setFont('helvetica', 'normal');
        pdf.text(kw as string, m + 4, y);
        pdf.text((vol as number).toString(), m + 95, y, { align: 'right' });
        pdf.setFont('helvetica', 'bold');
        pdf.text((pos as number).toString(), m + 125, y, { align: 'right' });
        pdf.setTextColor(...(col as number[]));
        pdf.text(stat as string, pw - m - 4, y, { align: 'right' });
        y += 6.5;
      });

      y += 6;
      const h1 = 24;
      pdf.setFillColor(254, 226, 226);
      pdf.roundedRect(m, y, cw, h1, 2, 2, 'F');
      y += 6;
      pdf.setFontSize(10);
      pdf.setTextColor(153, 27, 27);
      pdf.setFont('helvetica', 'bold');
      pdf.text('ANALYSE:', m + 4, y);
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'normal');
      y += 5.5;
      pdf.text('3 mots-cles branded OK - 5 commerciaux invisibles (pos 32-45)', m + 4, y);
      y += 5;
      pdf.text('"restaurant lyon 6" (3800 rech/mois) position 32 = perte majeure', m + 4, y);

      y += 16;
      addFooter('8 mots-cles - 3 branded performants - 5 commerciaux a optimiser d\'urgence');

      // PAGE 4: CONCURRENCE
      addPage();
      addSection('Analyse Concurrentielle');

      pdf.setFillColor(...black);
      pdf.rect(m, y, cw, 10, 'F');
      pdf.setFontSize(9);
      pdf.setTextColor(...white);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Concurrent', m + 4, y + 7);
      pdf.text('Trafic', m + 85, y + 7, { align: 'right' });
      pdf.text('KW', m + 110, y + 7, { align: 'right' });
      pdf.text('DA', m + 135, y + 7, { align: 'right' });
      pdf.text('Ecart', pw - m - 4, y + 7, { align: 'right' });
      y += 10;

      [
        ['Tetedoie', 8200, 245, 52],
        ['Le Gourmet de Seze', 6800, 198, 48],
        ['Daniel & Denise', 5900, 165, 45],
        ['Le Passe Temps', 4200, 142, 42],
        ['Pierre Orsi', 7500, 210, 50]
      ].forEach(([name, traf, kw, da], i) => {
        if (i % 2 === 0) {
          pdf.setFillColor(252, 252, 252);
          pdf.rect(m, y - 3, cw, 6.5, 'F');
        }
        pdf.setFontSize(9);
        pdf.setTextColor(...black);
        pdf.setFont('helvetica', 'bold');
        pdf.text(name as string, m + 4, y);
        pdf.setFont('helvetica', 'normal');
        pdf.text((traf as number).toString(), m + 85, y, { align: 'right' });
        pdf.text((kw as number).toString(), m + 110, y, { align: 'right' });
        pdf.setFont('helvetica', 'bold');
        pdf.text((da as number).toString(), m + 135, y, { align: 'right' });
        const ecart = Math.round(((traf as number) / 3150 - 1) * 100);
        pdf.setTextColor(...red);
        pdf.text(`+${ecart}%`, pw - m - 4, y, { align: 'right' });
        y += 6.5;
      });

      y += 10;
      addFooter('Concurrents +100-160% trafic - Retard systematique sur tous segments');

      // PAGE 5: LOCAL & GMB
      addPage();
      addSection('Presence Locale & GMB');

      pdf.setFontSize(10);
      pdf.setTextColor(...black);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Diagnostic Google Business Profile', m, y);
      y += 8;

      const h2 = 22;
      pdf.setFillColor(254, 243, 199);
      pdf.roundedRect(m, y, cw, h2, 2, 2, 'F');
      y += 6;
      pdf.setFontSize(9);
      pdf.setTextColor(146, 64, 14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('SITUATION:', m + 4, y);
      pdf.setFont('helvetica', 'normal');
      y += 5.5;
      pdf.text('Fiche GMB existe mais mal detectee (profil ~65% complet)', m + 4, y);
      y += 5;
      pdf.text('WooRank rapporte "Missing GMB" = probleme optimisation technique', m + 4, y);

      y += 14;
      pdf.setFontSize(10);
      pdf.setTextColor(...black);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Plan GEO 30 Jours', m, y);
      y += 7;

      ['Completion GMB 100%', 'Ajout 50 photos pro', 'Posts 3x/semaine', 'Strategie avis'].forEach(a => {
        pdf.setFillColor(...green);
        pdf.circle(m + 3, y - 1.5, 1, 'F');
        pdf.setFontSize(10);
        pdf.setTextColor(...black);
        pdf.setFont('helvetica', 'normal');
        pdf.text(a, m + 7, y);
        y += 6;
      });

      y += 8;
      addFooter('GMB existe mais sous-optimise - Plan 30 jours pour Top 3 Local Pack');

      // PAGE 6: PLAN 3 MOIS
      addPage();
      addSection('Plan 3 Mois');

      pdf.setFontSize(12);
      pdf.setTextColor(...black);
      pdf.setFont('helvetica', 'bold');
      pdf.text('MOIS 1: Quick Wins', m, y);
      y += 8;

      ['Schema.org + llms.txt', 'GMB optimisation', 'Minification assets'].forEach(a => {
        pdf.setFillColor(...green);
        pdf.circle(m + 3, y - 1.5, 1, 'F');
        pdf.setFontSize(10);
        pdf.setTextColor(...black);
        pdf.setFont('helvetica', 'normal');
        pdf.text(a, m + 7, y);
        y += 6;
      });

      y += 6;
      const h3 = 50;
      pdf.setFillColor(...black);
      pdf.roundedRect(m, y, cw, h3, 3, 3, 'F');
      y += 14;
      pdf.setFillColor(...gold);
      pdf.circle(pw / 2, y, 9, 'F');
      pdf.setTextColor(...black);
      pdf.setFontSize(18);
      pdf.text('LOCK', pw / 2 - 9, y + 2);
      y += 16;
      pdf.setTextColor(...gold);
      pdf.setFontSize(16);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Mois 2-3: Premium', pw / 2, y, { align: 'center' });
      y += 8;
      pdf.setTextColor(200, 200, 200);
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.text('16 actions + Timeline + ROI', pw / 2, y, { align: 'center' });

      y += 28;
      addFooter('Mois 1 detaille - Mois 2-3 inclus Pack Premium');

      // PAGE 7: IA 2026
      addPage();
      addSection('Visibilite IA 2026');

      pdf.setFontSize(10);
      pdf.setTextColor(...black);
      pdf.setFont('helvetica', 'normal');
      pdf.text('40% des recherches 2026 via IA (ChatGPT/Gemini)', m, y);
      y += 10;

      pdf.setFillColor(...black);
      pdf.rect(m, y, cw, 9, 'F');
      pdf.setFontSize(8);
      pdf.setTextColor(...white);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Metrique', m + 4, y + 6);
      pdf.text('Actuel', m + 95, y + 6, { align: 'right' });
      pdf.text('Objectif', m + 135, y + 6, { align: 'right' });
      pdf.text('Ecart', pw - m - 4, y + 6, { align: 'right' });
      y += 9;

      [
        ['AI Visibility', '26/100', '75/100', '+49'],
        ['Pages citees', '4', '35', '+31'],
        ['AI Audience/mois', '1,030', '8,000', '+677%'],
        ['Fichier llms.txt', 'Absent', 'OK', '-']
      ].forEach((row, i) => {
        if (i % 2 === 0) {
          pdf.setFillColor(252, 252, 252);
          pdf.rect(m, y - 2.5, cw, 6, 'F');
        }
        pdf.setFontSize(9);
        pdf.setTextColor(...black);
        pdf.setFont('helvetica', 'normal');
        pdf.text(row[0], m + 4, y);
        pdf.text(row[1], m + 95, y, { align: 'right' });
        pdf.text(row[2], m + 135, y, { align: 'right' });
        pdf.setTextColor(...red);
        pdf.setFont('helvetica', 'bold');
        pdf.text(row[3], pw - m - 4, y, { align: 'right' });
        y += 6;
      });

      y += 8;
      addFooter('Visibilite IA 26/100 - 1000+ recommandations/mois manquees - Llms.txt urgent');

      // PAGE 8: BACKLINKS
      addPage();
      addSection('Backlinks & Autorite');

      const h4 = 18;
      pdf.setFillColor(254, 226, 226);
      pdf.roundedRect(m, y, cw, h4, 2, 2, 'F');
      y += 6;
      pdf.setFontSize(10);
      pdf.setTextColor(153, 27, 27);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Score WooRank: FAIBLE', m + 4, y);
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'normal');
      y += 6;
      pdf.text('Traffic Rank: 8,363,146eme mondial - Profil backlink non robuste', m + 4, y);

      y += 14;
      pdf.setFontSize(10);
      pdf.setTextColor(...black);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Sources Detectees (SEMrush)', m, y);
      y += 7;

      [['michelin.com', '39%', '92'],
       ['tripadvisor.fr', '11%', '88'],
       ['leprogres.fr', '10%', '72'],
       ['thefork.fr', '8%', '75']
      ].forEach((src, i) => {
        if (i % 2 === 0) {
          pdf.setFillColor(252, 252, 252);
          pdf.rect(m, y - 2.5, cw, 6, 'F');
        }
        pdf.setFontSize(9);
        pdf.setTextColor(...black);
        pdf.setFont('helvetica', 'normal');
        pdf.text(src[0], m + 4, y);
        pdf.text(src[1], m + 110, y, { align: 'right' });
        pdf.setFont('helvetica', 'bold');
        pdf.text(`DA ${src[2]}`, pw - m - 4, y, { align: 'right' });
        y += 6;
      });

      y += 8;
      addFooter('Bonnes sources autorite - Volume total insuffisant (~250 vs 600 concurrents)');

      // PAGE 9: PRIVATISATION
      addPage();
      addSection('Privatisation & Evenements B2B');

      pdf.setFontSize(10);
      pdf.setTextColor(...black);
      pdf.setFont('helvetica', 'bold');
      pdf.text('3 Salons Privatifs Existants', m, y);
      y += 8;

      [['Salon des Chefs', '12 pers', 'Collection vestes cuisiniers'],
       ['Salon de la Famille', '8 pers', 'Histoire dynastie Marguin'],
       ['Salon des Medailles', '12 pers', 'Legion Honneur, Merite']
      ].forEach(salon => {
        pdf.setFillColor(...lightGray);
        pdf.roundedRect(m, y, cw, 12, 2, 2, 'F');
        y += 4;
        pdf.setFontSize(10);
        pdf.setTextColor(...black);
        pdf.setFont('helvetica', 'bold');
        pdf.text(salon[0], m + 4, y);
        pdf.setFontSize(8);
        pdf.setTextColor(...gray);
        pdf.setFont('helvetica', 'normal');
        y += 5;
        pdf.text(`${salon[1]} - ${salon[2]}`, m + 4, y);
        y += 8;
      });

      const h5 = 16;
      pdf.setFillColor(220, 252, 231);
      pdf.roundedRect(m, y, cw, h5, 2, 2, 'F');
      y += 6;
      pdf.setFontSize(10);
      pdf.setTextColor(22, 101, 52);
      pdf.setFont('helvetica', 'bold');
      pdf.text('QUICK WIN:', m + 4, y);
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'normal');
      y += 5.5;
      pdf.text('Optimiser page privatisation = 15-25 events/an = 40-80k EUR', m + 4, y);

      y += 12;
      addFooter('Page privatisation existe - SEO a optimiser - Potentiel B2B 40-80k EUR/an');

      // PAGE 10: INTERNATIONAL
      addPage();
      addSection('Visibilite Internationale');

      pdf.setFontSize(10);
      pdf.setTextColor(...black);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Lyon: 800k touristes etrangers/an - 60% anglophones', m, y);
      y += 10;

      pdf.setFillColor(...black);
      pdf.rect(m, y, cw, 9, 'F');
      pdf.setFontSize(8);
      pdf.setTextColor(...white);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Langue', m + 4, y + 6);
      pdf.text('Coverage', m + 80, y + 6, { align: 'right' });
      pdf.text('Trafic', m + 120, y + 6, { align: 'right' });
      pdf.text('Statut', pw - m - 4, y + 6, { align: 'right' });
      y += 9;

      [['FR', '100%', '2,900', 'OK', green],
       ['EN', '45%', '120', 'Faible', orange],
       ['ES', '20%', '80', 'Critique', red],
       ['PT', '10%', '50', 'Critique', red]
      ].forEach((lang, i) => {
        if (i % 2 === 0) {
          pdf.setFillColor(252, 252, 252);
          pdf.rect(m, y - 2.5, cw, 6, 'F');
        }
        pdf.setFontSize(9);
        pdf.setTextColor(...black);
        pdf.setFont('helvetica', 'normal');
        pdf.text(lang[0], m + 4, y);
        pdf.text(lang[1], m + 80, y, { align: 'right' });
        pdf.text(lang[2], m + 120, y, { align: 'right' });
        pdf.setTextColor(...(lang[4] as number[]));
        pdf.setFont('helvetica', 'bold');
        pdf.text(lang[3], pw - m - 4, y, { align: 'right' });
        y += 6;
      });

      y += 8;
      const h6 = 14;
      pdf.setFillColor(254, 226, 226);
      pdf.roundedRect(m, y, cw, h6, 2, 2, 'F');
      y += 6;
      pdf.setFontSize(9);
      pdf.setTextColor(153, 27, 27);
      pdf.setFont('helvetica', 'bold');
      pdf.text('PERTE:', m + 4, y);
      pdf.setFont('helvetica', 'normal');
      y += 5;
      pdf.text('400k+ touristes anglophones non cibles = 30-50k EUR/an manques', m + 4, y);

      y += 12;
      addFooter('Anglais 45% seulement - Marche touristique sous-exploite - 30-50k EUR perdus/an');

      // PAGE 11: CHATBOT
      addPage();
      addSection('Chatbot IA Conversationnel 24/7');

      pdf.setFontSize(10);
      pdf.setTextColor(...black);
      pdf.setFont('helvetica', 'normal');
      pdf.text('67% visiteurs partent sans reserver sans reponse immediate', m, y);
      y += 10;

      const cbW = (cw - 15) / 4;
      let cbx = m;
      [[blue, '24/7'], [purple, '4 lang'], [green, '<3s'], [gold, '+35%']].forEach(([col, val]) => {
        pdf.setFillColor(...(col as number[]));
        pdf.roundedRect(cbx, y, cbW, 20, 2, 2, 'F');
        pdf.setFontSize(18);
        pdf.setTextColor(...white);
        pdf.setFont('helvetica', 'bold');
        pdf.text(val as string, cbx + cbW / 2, y + 13, { align: 'center' });
        cbx += cbW + 5;
      });

      y += 26;
      const h7 = 12;
      pdf.setFillColor(220, 252, 231);
      pdf.roundedRect(m, y, cw, h7, 2, 2, 'F');
      y += 6;
      pdf.setFontSize(10);
      pdf.setTextColor(22, 101, 52);
      pdf.setFont('helvetica', 'bold');
      pdf.text('IMPACT:', m + 4, y);
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'normal');
      pdf.text('15-25 resa/mois = 12-20k EUR/an (+200 EUR/mois)', m + 20, y);

      y += 12;
      addFooter('Chatbot GPT-4 multilingue - Option +200 EUR/mois Premium - Inclus Signature');

      // PAGE 12: CTA FINAL
      addPage();
      
      y = 25;
      pdf.setFontSize(34);
      pdf.setTextColor(...black);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Transformez Votre', m, y);
      y += 14;
      pdf.setTextColor(...gold);
      pdf.text('Visibilite Digitale', m, y);
      
      y += 12;
      pdf.setFontSize(11);
      pdf.setTextColor(...gray);
      pdf.setFont('helvetica', 'normal');
      pdf.text('120-300k EUR/an de croissance identifies', m, y);
      y += 4;
      pdf.setFillColor(...gold);
      pdf.rect(m, y, 70, 2, 'F');

      y += 18;

      // PACK PREMIUM PLEINE LARGEUR
      pdf.setFillColor(254, 243, 199);
      pdf.roundedRect(m, y, cw, 92, 3, 3, 'F');
      pdf.setDrawColor(...gold);
      pdf.setLineWidth(2);
      pdf.roundedRect(m, y, cw, 92, 3, 3, 'S');
      
      pdf.setFillColor(...gold);
      pdf.roundedRect(m + 6, y + 6, 40, 8, 2, 2, 'F');
      pdf.setFontSize(10);
      pdf.setTextColor(...black);
      pdf.setFont('helvetica', 'bold');
      pdf.text('RECOMMANDE', m + 26, y + 11, { align: 'center' });
      
      y += 24;
      pdf.setFontSize(24);
      pdf.text('Pack Premium', pw / 2, y, { align: 'center' });
      y += 10;
      pdf.setFontSize(10);
      pdf.setTextColor(...gray);
      pdf.setFont('helvetica', 'normal');
      pdf.text('SEO + GEO + Content + Support', pw / 2, y, { align: 'center' });
      
      y += 16;
      pdf.setFontSize(46);
      pdf.setTextColor(...gold);
      pdf.setFont('helvetica', 'bold');
      pdf.text('2,000', pw / 2 - 22, y, { align: 'center' });
      pdf.setFontSize(18);
      pdf.setTextColor(...gray);
      pdf.setFont('helvetica', 'normal');
      pdf.text('EUR/mois', pw / 2 + 20, y, { align: 'left' });
      y += 9;
      pdf.setFontSize(9);
      pdf.text('Engagement 12 mois', pw / 2, y, { align: 'center' });

      y += 14;
      const features = ['Audit complet', 'SEO + GMB', 'Netlinking 50/an', 'Content 24/an', 'Report mensuel', '3 langues', 'Support pro'];
      let yl = y, yr = y;
      const half = Math.ceil(features.length / 2);
      features.slice(0, half).forEach(f => {
        pdf.setFontSize(9);
        pdf.setTextColor(...green);
        pdf.text('>', m + 10, yl);
        pdf.setTextColor(...black);
        pdf.setFont('helvetica', 'normal');
        pdf.text(f, m + 14, yl);
        yl += 5.5;
      });
      features.slice(half).forEach(f => {
        pdf.setFontSize(9);
        pdf.setTextColor(...green);
        pdf.text('>', pw / 2 + 4, yr);
        pdf.setTextColor(...black);
        pdf.setFont('helvetica', 'normal');
        pdf.text(f, pw / 2 + 8, yr);
        yr += 5.5;
      });

      y = Math.max(yl, yr) + 4;
      pdf.setFillColor(22, 101, 52);
      pdf.roundedRect(m + 12, y, cw - 24, 10, 2, 2, 'F');
      pdf.setFontSize(13);
      pdf.setTextColor(...white);
      pdf.setFont('helvetica', 'bold');
      pdf.text('ROI Attendu: 300-450%', pw / 2, y + 7, { align: 'center' });

      y += 20;

      // Contact final
      pdf.setFillColor(...black);
      pdf.roundedRect(m, y, cw, 34, 3, 3, 'F');
      y += 11;
      pdf.setFontSize(28);
      pdf.setTextColor(...gold);
      pdf.text('STRATOS', pw / 2, y, { align: 'center' });
      y += 8;
      pdf.setFontSize(9);
      pdf.setTextColor(200, 200, 200);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Strategie Digitale pour Restaurants', pw / 2, y, { align: 'center' });
      y += 8;
      pdf.setFontSize(11);
      pdf.setTextColor(...white);
      pdf.setFont('helvetica', 'bold');
      pdf.text('admin@stratos-hospitality.com', pw / 2, y, { align: 'center' });
      y += 7;
      pdf.setTextColor(...gold);
      pdf.text('+33 6 64 27 60 32', pw / 2, y, { align: 'center' });

      addFooter('Pack Premium 2,000 EUR/mois - Demarrage J+1 - ROI 300-450%');

      pdf.save('Pre-Audit-Le-President-STRATOS.pdf');
      setIsGenerating(false);
    } catch (error) {
      console.error('Erreur:', error);
      setIsGenerating(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <Card className="p-8">
          <div className="text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-stratos-gold to-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <Sparkles className="w-10 h-10 text-white" />
            </div>
            
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Pre-Audit PDF Le President
            </h1>
            <p className="text-xl text-gray-600 mb-2">
              Lyon 6eme - Chef Christophe Marguin
            </p>
            <p className="text-gray-500 mb-8">
              PDF professionnel optimise - Code refait proprement
            </p>

            <div className="grid grid-cols-3 gap-4 mb-8">
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <p className="text-sm text-gray-600 mb-1">Pages</p>
                <p className="text-2xl font-bold text-gray-900">12</p>
              </div>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-sm text-gray-600 mb-1">Poids</p>
                <p className="text-2xl font-bold text-gray-900">~400 KB</p>
              </div>
              <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                <p className="text-sm text-gray-600 mb-1">Qualite</p>
                <p className="text-2xl font-bold text-gray-900">Premium</p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border border-orange-200 rounded-lg p-6 mb-8">
              <h3 className="font-semibold text-gray-900 mb-3">Contenu :</h3>
              <div className="grid grid-cols-2 gap-3 text-left text-sm">
                <div>
                  <p className="font-semibold text-green-700 mb-2">Pages incluses:</p>
                  <ul className="space-y-1 text-gray-700 text-xs">
                    <li>• Couverture premium</li>
                    <li>• Synthese + opportunite</li>
                    <li>• 8 mots-cles analyses</li>
                    <li>• 5 concurrents Lyon</li>
                    <li>• Presence locale/GMB</li>
                    <li>• Plan 3 mois (Mois 1 + masque)</li>
                  </ul>
                </div>
                <div>
                  <p className="font-semibold text-blue-700 mb-2">Suite:</p>
                  <ul className="space-y-1 text-gray-700 text-xs">
                    <li>• Visibilite IA 2026</li>
                    <li>• Backlinks & autorite</li>
                    <li>• Privatisation B2B</li>
                    <li>• International/Tourisme</li>
                    <li>• Chatbot IA 24/7</li>
                    <li>• CTA Pack Premium</li>
                  </ul>
                </div>
              </div>
            </div>

            <Button
              onClick={generatePDF}
              disabled={isGenerating}
              size="lg"
              className="bg-gradient-to-r from-stratos-gold to-orange-500 hover:from-stratos-gold-dark hover:to-orange-600 text-white font-bold text-lg px-12 py-6 shadow-xl"
            >
              {isGenerating ? (
                <>
                  <Loader2 className="w-6 h-6 mr-3 animate-spin" />
                  Generation...
                </>
              ) : (
                <>
                  <Download className="w-6 h-6 mr-3" />
                  Generer PDF Premium
                </>
              )}
            </Button>

            <p className="text-xs text-gray-500 mt-4">
              12 pages - Code propre - Lisible - Pack Premium recommande
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};
